import { useMsal } from '@azure/msal-react';
import { getAuthHeader, REACT_APP_PS_PORTAL_API_URI } from 'authHelper';
import apiFetch from 'apiFetch';
import { useRef, useState } from 'react';
import { Toast, ToastContainer, Card } from 'react-bootstrap';
import {
   BULK_UPLOAD_TEMPLATE_CSV,
   getBulkUploadErrorMessage,
   MAX_VISIBLE_BULK_UPLOAD_ERRORS,
   parseBulkUploadRows,
   readUploadRows,
   validateBulkUploadData
} from './bulkUploadValidation';

const BulkUpload = (props) => {
   const { instance, accounts } = useMsal()
   const [bulkData, setBulkData] = useState([])
   const [submitting, setSubmitting] = useState(false)
   const [file, setFile] = useState({
       fileName: '',
       errors: ''
   })
   const inputRef = useRef(null);
   const [showToastMsg, setShowToastMsg] = useState({ visible: false, msg: '' })
   const templateHref = `data:text/csv;charset=utf-8,${encodeURIComponent(BULK_UPLOAD_TEMPLATE_CSV)}`
   const readUploadFile = async (e) => {
       e.preventDefault();
       if (e.target.files) {
           const uploadFile = e.target.files[0]

           try {
               const rows = await readUploadRows(uploadFile)
               const uploadData = parseBulkUploadRows(rows)

                if(!uploadFile) {
                    return;
                }

               if (uploadData.errors.length > 0) {
                   setBulkData([]);
                   setFile({ fileName: '', errors: uploadData.errors.slice(0, MAX_VISIBLE_BULK_UPLOAD_ERRORS).join('\n') });
                   inputRef.current.value = null;
                   return;
               }

               setBulkData(uploadData.data);
               setFile({ fileName: uploadFile.name, errors: '' });
           }
           catch (exception) {
               setBulkData([]);
               setFile({ fileName: '', errors: exception.message ?? 'Unable to read file. Please check the file and try again.' });
               inputRef.current.value = null;
           }
       }
   }

   async function uploadPractices(event) {
       event.preventDefault();
       const validationErrors = validateBulkUploadData(bulkData)

       if (validationErrors.length > 0) {
           setFile({ fileName: '', errors: validationErrors.slice(0, MAX_VISIBLE_BULK_UPLOAD_ERRORS).join('\n') });
           setBulkData([]);
           inputRef.current.value = null;
           return;
       }
       if (file.fileName && bulkData.length > 0) {
           setSubmitting(true);
           try {
               const authHeader = await getAuthHeader(instance, accounts)
               const httpConfig = {
                   headers: authHeader
               }

               await apiFetch.post(`${REACT_APP_PS_PORTAL_API_URI}/practices/bulkUpload`, bulkData, httpConfig)
               setShowToastMsg({ visible: true, msg: 'File uploaded successfully' })
               props.onUpload();
               setBulkData([]);
               setFile({ fileName: '', errors: '' });
               inputRef.current.value = null;
           }
           catch (exception) {
               setFile({ fileName: '', errors: getBulkUploadErrorMessage(exception) });
               setBulkData([]);
               inputRef.current.value = null;
           }
           finally {
               setSubmitting(false);
           }
       }
       else {
           setFile({ fileName: '', errors: 'Please upload file in excel or csv format' });
           return;
       }
   }

   return (
       <>
           <ToastContainer className="p-3" position="bottom-center">
               <Toast onClose={() => setShowToastMsg({ visible: false, msg: '' })} show={showToastMsg.visible} delay={3000} autohide>
                   <Toast.Header>
                       <strong className="me-auto">Primary Sense</strong>
                   </Toast.Header>
                   <Toast.Body>{showToastMsg.msg}</Toast.Body>
               </Toast>
           </ToastContainer>
           <Card className="mt-4">
               <Card.Body>
                   <Card.Title>Bulk Practice Upload</Card.Title>
                   <Card.Text className="d-flex flex-row align-items-start mt-3 w-100">
                       <span className="flex-column mb-0 w-75">
                           <input type="file" ref={inputRef} className="form-control" id="inputGroupFile04" aria-label="Upload" accept=".xlsx,.csv" onChange={readUploadFile} />
                           <a href={templateHref}
                            download="bulk-practice-upload-template.csv"
                            className="btn btn-outline-secondary btn-sm mt-3">
                            Download CSV template</a>
                           {file.errors && <p className="invalid-feedback d-block" style={{ whiteSpace: 'pre-line' }}>{file.errors}</p>}
                       </span>
                       <button className="btn btn-outline-primary w-25" disabled={submitting} type="button" id="inputGroupFileAddon04" onClick={uploadPractices}>
                   Upload
                       </button>
                   </Card.Text>
               </Card.Body>
           </Card>
       </>
   )
}
export default BulkUpload;